import { useId } from 'react'
import { useIntl } from 'react-intl'

import { PaperclipIcon } from 'lucide-react'

import { cn } from '@/lib/utils.ts'

export interface SupportContextBoxProps {
  readonly you: string
  readonly page: string
  readonly system: string
  readonly className?: string
}

export const SupportContextBox = ({ you, page, system, className }: SupportContextBoxProps) => {
  const intl = useIntl()
  const titleId = useId()
  const rows = [
    ['soutien.context.you', you],
    ['soutien.context.page', page],
    ['soutien.context.system', system],
  ] as const

  return (
    <section
      aria-labelledby={titleId}
      className={cn('flex flex-col gap-2.5 rounded-[4px] border border-gray-200 bg-gray-50 px-4 py-3.5', className)}>
      <div className="flex items-center gap-2">
        <PaperclipIcon aria-hidden className="size-4 text-gray-600" />
        <h3 id={titleId} className="text-base font-bold text-gray-800">
          {intl.formatMessage({ id: 'soutien.context.title' })}
        </h3>
      </div>
      <dl className="grid grid-cols-[96px_minmax(0,1fr)] gap-x-3 gap-y-1.5 text-sm">
        {rows.map(([id, value]) => (
          <div key={id} className="contents">
            <dt className="text-gray-500">{intl.formatMessage({ id })}</dt>
            <dd className="break-words text-gray-900">{value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
